import { LinearProgress } from '@material-ui/core';

export const LoadingSpinner = () => <LinearProgress style={{width: '100%'}} />;